<template>
    <div class="configurator-preselector">
        <PreselectorStep class="preselector-step" name="make" title="Marke wählen" order="first" priority="Audi,BMW,VW,Mercedes Benz,Opel" />
        <PreselectorStep class="preselector-step" name="model" title="Modell wählen" order="second" />
        <PreselectorStep class="preselector-step" name="year" title="Erstzulassung ab" order="third" />
    </div>
</template>
<script>
import PreselectorStep from "./PreselectorStep";

export default {
    name: "Preselector",
    components: {
        PreselectorStep
    }
}
</script>
<style lang="scss" scoped>
    @import "~@/assets/vars";

    .configurator-preselector {
        @include breakpoint(fromlarge) {
            width:75%;
            display: flex;
            justify-content: space-between;
            gap: 20px;
        }
        @include breakpoint(extralarge) {
            gap:40px;
        }
        .preselector-step {
            margin-bottom:16px;
            @include breakpoint(fromlarge) {
                width: 33%;
                margin-bottom:0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/station-components/Preselector.vue